<template>
  <div class="pc-distribute">
    <inline-loader v-if="loading" :loading="loading" />
    <template v-else>
      <div class="pc-distribute-header">
        <i-button class="ms-button-text" type="text" @click="closePayment">
          <icon type="ios-arrow-back" />
          Назад к списку
        </i-button>
        <i-button type="error" @click="handleDelete">
          Удалить платеж
        </i-button>
      </div>
      <div class="pc-distribute-info">
        <pc-item :payment="activePayment" :single="true" />
      </div>
      <div
        class="pc-distribute-distributed"
        v-if="activePayment.payments && activePayment.payments.length"
      >
        <div class="pc-distribute-title ms-help">
          Созданные платежи
        </div>
        <div class="pc-distribute-distributed-list">
          <pc-distributed-item
            v-for="payment in activePayment.payments"
            :key="payment.id"
            :payment="payment"
          />
        </div>
      </div>
      <div class="pc-distribute-control" v-if="!newPayment">
        <i-button size="default" type="success" @click="addNewPayment">
          Добавить новый платеж
        </i-button>
      </div>
      <div class="pc-distribute-created" v-else>
        <div class="pc-distribute-title ms-help">
          Создание нового платежа
        </div>
        <pc-created
          :payment="newPayment"
          @save="createNewPayment"
          @cancel="cancelNewPayment"
        />
      </div>
    </template>

    <modal :z-index="2000" v-model="deleteModal" width="360">
      <p slot="header" style="color:#f60;text-align:center">
        <icon type="ios-information-circle" />
        <span style="margin-left: 4px">Удаление платежа</span>
      </p>
      <div style="text-align:center">
        <p class="ms-text">
          Вы уверены, что хотите удалить данный платеж из системы?
        </p>
      </div>
      <div slot="footer">
        <i-button
          type="error"
          size="default"
          long
          :loading="deleting"
          @click="deletePayment"
        >
          Удалить
        </i-button>
      </div>
    </modal>
  </div>
</template>

<script>
import InlineLoader from '@/components/loaders/inline-loader'
import PcItem from './pc-item'
import PcDistributedItem from './pc-distributed-item'
import PcCreated from './pc-created'
import { formatDefaultDate } from '@/utils'

const payment = {
  contract_id: null,
  from_company_id: null,
  to_company_id: null,
  type_id: 1,
  act_id: null,
  date: '',
  value: null,
  description: '',
  roadmap_payments: []
}

export default {
  components: {
    InlineLoader,
    PcItem,
    PcDistributedItem,
    PcCreated
  },
  data () {
    return {
      loading: false,
      deleting: false,
      deleteModal: false,
      newPayment: null
    }
  },
  computed: {
    activePayment () {
      return this.$store.state.paymentsControl.activePayment
    },
    newPayments () {
      return this.$store.state.paymentsControl.newPayments
    }
  },
  methods: {
    closePayment () {
      this.$store.commit('TOGGLE_PC_PROP', {
        field: 'newPayments',
        value: []
      })
      this.$store.commit('TOGGLE_PC_PROP', {
        field: 'contracts',
        value: []
      })
      this.$store.commit('TOGGLE_PC_PROP', {
        field: 'activePayment',
        value: null
      })
    },
    handleDelete () {
      this.deleteModal = true
    },
    async deletePayment () {
      try {
        this.deleting = true

        const url = `objectInfo/payment_accountings?ids=${this.activePayment.id}`
        await this.$store.dispatch('DELETE_REQUEST', { url })

        this.closePayment()
        this.$emit('update')
        this.deleting = false
      } catch (error) {
        console.log(error)
        this.deleting = false
      }
    },
    addNewPayment () {
      const { date, from_company_id, to_company_id } = this.activePayment

      this.newPayment = {
        ...payment,
        roadmap_payments: [],
        date: formatDefaultDate(date),
        from_company_id: from_company_id || null,
        to_company_id: to_company_id || null
      }
    },
    cancelNewPayment () {
      this.newPayment = null
    },
    createNewPayment () {
      this.cancelNewPayment()
      this.closePayment()
      this.$emit('update')
    },
    async getData () {
      try {
        this.loading = true

        const { from_company_inn, to_company_inn, incoming_payment } = this.activePayment
        const url = incoming_payment
          ? `page/project?inn=${from_company_inn}&order=code_asc`
          : `page/contragent?performer_inn=${to_company_inn}`
        const contracts = await this.$store.dispatch('GET_REQUEST', { url })

        this.$store.commit('TOGGLE_PC_PROP', {
          field: 'contracts',
          value: contracts
        })

        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    }
  },
  created () {
    this.getData()
  }
}
</script>

<style lang="less">
.pc-distribute {
  position: relative;

  &-header {
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;

    .ms-button-text {
      span {
        display: flex;
        align-items: center;

        i {
          margin-right: 4px;
        }
      }
    }
  }

  &-distributed {
    margin-top: 8px;
  }

  &-control {
    display: flex;
    justify-content: center;
    margin-top: 16px;
  }

  &-created {
    margin-top: 16px;
  }

  &-title {
    margin-bottom: 4px;
  }
}
</style>
